$(document).ready(function () {

    if ($("#datepicker").length > 0) {
        handleEventList();
    }
    $('#dialog').on('dialogclose', function (event) {
        $("body").removeClass("modal-open");
    });
  
    $("#dialog").dialog({
      autoOpen: false,
      title: "イベントの詳細内容",
      dialogClass: "cs-event-dialog",
      create: function (event, ui) {
          var widget = $(this).dialog("widget");
          $("button.ui-button.ui-corner-all.ui-widget.ui-button-icon-only.ui-dialog-titlebar-close").html("")
          $("button.ui-button.ui-corner-all.ui-widget.ui-button-icon-only.ui-dialog-titlebar-close").text("X")
          //         $(".ui-dialog-titlebar-close span", widget).html('X');
      },
      maxWidth: 600,
      maxHeight: 500,
      width: 900,
      show: {
          effect: "fade",
          duration: 400
      },
      hide: {
          effect: "fade",
          duration: 400
      },
      modal: true,
      transitionMask: true,
      responsive: true
  });
});

$(function () {
    $('a[href*=\\#]:not([href=\\#])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var $target = $(this.hash);
            $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
            if ($target.length) {
                if ($(this).parents('.menuBox').length) {
                    setTimeout(function () {
                        var targetOffset = $target.offset().top;
                        $('html,body').animate({
                            scrollTop: targetOffset
                        }, 1000);
                    }, 100);
                } else {
                    var targetOffset = $target.offset().top;
                    $('html,body').animate({
                        scrollTop: targetOffset
                    }, 1000);
                }
                return false;
            }
        }
    });

    var state = false;
    var scrollpos;
    $('.menu').on('click', function(){
        if(state == false) {
            scrollpos = $(window).scrollTop(); 
            $('body').addClass('fixed').css({'top': -scrollpos}); 
            $('.menuBox').stop().fadeToggle();
            $('.menuBg').stop().fadeToggle();
            $('.menuBox .menuInner').hide();
            $('.menuBox .step1').show();
            $('chat').hide();
            state = true;
        } else {
            $('body').removeClass('fixed').css({'top': 0});
            window.scrollTo( 0 , scrollpos ); 
            $('.menuBox').fadeOut();
            $('.menuBg').stop().fadeToggle();
        }
        return false;
    });

    $('.searchItem').on('click', function(){
        var chat = $('chat');
        if(state == false) {
            scrollpos = $(window).scrollTop(); 
            $('body').addClass('fixed').css({'top': -scrollpos}); 
            $('.menuBox').stop().fadeToggle();
            $('.menuBg').stop().fadeToggle();
            $('.menuBox .menuInner').hide();
            $('.menuBox .menuSearchBox').show();
            state = true;
            if (chat) {
                chat.hide();
            }
        } else {
            $('body').removeClass('fixed').css({'top': 0});
            window.scrollTo( 0 , scrollpos ); 
            $('.menuBox').fadeOut();
            $('.menuBg').stop().fadeToggle();
        }
        return false;
    });

    $('.menuBg,.menuBox .step1 .close,.menuBox .menuSearchBox .close').click(function(){
        var chat = $('chat');
        $('body').removeClass('fixed').css({'top': 0});
        window.scrollTo( 0 , scrollpos );
        $('.menuBox').fadeOut();
        $('.menuBg').stop().fadeToggle();
        state = false;
        if (chat) {
            chat.show();
        }
    });

    $('.menuBox .menuUl a[data-link]').click(function(){
        var index = $(this).attr('data-link');
        $('.menuBox .menuInner').hide();
        $('.menuBox .menuInner[data-target='+index+']').show();
        return false;
    });

    $('.menuBox .step2 .close').click(function(){
        $('.menuBox .step2').hide();
        $('.menuBox .step1').show();
    });

    $("#gHeader .hList > li:has(.naviBox)").hover(function () {
        $(this).children("a").addClass("on");
        $(this).children(".naviBox").show();
    }, function () {
        $(this).children("a").removeClass("on");
        $(this).children(".naviBox").hide();
    });
    $(".menuBox .menuList p").click(function(){
        $(this).toggleClass("on").next().stop().slideToggle(300);
    });
    if ($('.jsSelect01').length) {
        const edd = easydropdown('.jsSelect01', {
            behavior: {
                openOnFocus: true,
                useNativeUiOnMobile: false
            }
        });
    }
    if ($('.jsSelect02').length) {
        const edd = easydropdown('.jsSelect02', {
            behavior: {
                openOnFocus: true,
                useNativeUiOnMobile: true
            }
        });
    }
    if ($('.jsSelect').length) {
        const edd = easydropdown('.jsSelect', {
            behavior: {
                openOnFocus: true,
                useNativeUiOnMobile: false
            }
        });
    }
});

$(window).on('load', function () {
    var localLink = window.location + '';
    if (localLink.indexOf("#") != -1 && localLink.slice(-1) != '#') {
        localLink = localLink.slice(localLink.indexOf("#") + 1);
        $('html,body').animate({
            scrollTop: $('#' + localLink).offset().top
        }, 500);
    }
});

$(document).tooltip({
    track: true,
    tooltipClass: "cs-tooltip-event",
    items: ".highlight",
    content: function () {
        var element = $(this);
        var current_item = element.data().uiTooltipTitle;
            current_item = current_item.split('-');
        var current_item_format = new Date(current_item[0], (current_item[1] - 1), current_item[2], 7,0,0);
        var content_event = "";
        for (var i = 0; i < data_events.length; i++) {
            var start_date_format = data_events[i].start_date;
            var end_date_format = data_events[i].end_date;
            start_date_format = start_date_format.split(' ');
            end_date_format = end_date_format.split(' ');
          
            var start_date_ev = (new Date(start_date_format[0]));
            var end_date_ev = (new Date(end_date_format[0]));
            if (start_date_ev.getTime() <= current_item_format.getTime() && current_item_format.getTime() <=  end_date_ev.getTime()) {
                //              var tmp_start_date = new Date(data_events[i].start_date);
                //              var tmp_end_date = new Date(data_events[i].end_date);

                var tmp_start_date = data_events[i].start_date;
                tmp_start_date = tmp_start_date.split(' ');
                var tmp_start_date_time = tmp_start_date[1];
                tmp_start_date_time = tmp_start_date_time.split(':');

                var tmp_end_date = data_events[i].end_date;     
                tmp_end_date = tmp_end_date.split(' ');
                var tmp_end_date_time = tmp_end_date[1];
                tmp_end_date_time = tmp_end_date_time.split(':');

                // YYYY年M月D日 00:00 ~ 00:00
                var min_tmp_start_date = tmp_start_date_time[1];
                //                 if (min_tmp_start_date < 10) {
                //                     min_tmp_start_date = "0" + min_tmp_start_date;
                //                 }
                var min_tmp_end_date = tmp_end_date_time[1];
                //                 if (min_tmp_end_date < 10) {
                //                     min_tmp_end_date = "0" + min_tmp_end_date;
                //                 }
                var hour_tmp_start_date = tmp_start_date_time[0];
                //                 if (hour_tmp_start_date < 10) {
                //                     hour_tmp_start_date = "0" + hour_tmp_start_date;
                //                 }
                var hour_tmp_end_date = tmp_end_date_time[0];
                //                 if (hour_tmp_end_date < 10) {
                //                     hour_tmp_end_date = "0" + hour_tmp_end_date;
                //                 }
                var txt_start_date = start_date_ev.getFullYear() + "年" + (start_date_ev.getMonth() + 1) + "月" + start_date_ev.getDate() + "日 " + hour_tmp_start_date + ":" + min_tmp_start_date;
                var txt_end_date = end_date_ev.getFullYear() + "年" + (end_date_ev.getMonth() + 1) + "月" + end_date_ev.getDate() + "日 " + hour_tmp_end_date + ":" + min_tmp_end_date;
                content_event += "<div class='content_event'><div class='event_image'><img src='https://storage.googleapis.com/okafoods.appspot.com/" + data_events[i].image + "' /></div><div class='event_description'><p class='cs-tooltip-title'><strong>" + data_events[i].title + "</strong></p><p  class='cs-tooltip-info'>イベント時間:" + txt_start_date + " ~ " + txt_end_date + "</p><p class='event-description'>" + data_events[i].description + "</p></div></div>"
            }
        } 

        return "<div class='container_content_event'><div class='cs-tooltip-main-title'>イベント</div>" + content_event + "</div>";

        if (element.is("[title]")) {
            return element.attr("title");
        }
        if (element.is("img")) {
            return element.attr("alt");
        }
    },
    show: null, // show immediately
    open: function (event, ui) {
        if (typeof (event.originalEvent) === 'undefined') {
            return false;
        }

        var $id = $(ui.tooltip).attr('id');

        // close any lingering tooltips
        $('div.ui-tooltip').not('#' + $id).remove();

        // ajax function to pull in data and add it to the tooltip goes here
    },
    close: function (event, ui) {
        ui.tooltip.hover(function () {
                $(this).stop(true).fadeTo(400, 1);
            },
            function () {
                $(this).fadeOut('400', function () {
                    $(this).remove();
                });
            });
    }
});

$(window).on('load', function () {
    var localLink = window.location + '';
    if (localLink.indexOf("#") != -1 && localLink.slice(-1) != '#') {
        localLink = localLink.slice(localLink.indexOf("#") + 1);
        $('html,body').animate({
            scrollTop: $('#' + localLink).offset().top
        }, 500);
    }
});

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

//     if (month.length < 2) 
//         month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month,day ].join('-');
}

var getDaysArray = function (start, end) {
    if (start.getTime() === end.getTime()) {
        return [formatDate(new Date(start))]
    }
  
    
    for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
        
        arr.push(formatDate(new Date(dt)));
    }
    return arr;
};

function uniqueArray2(arr) {
    var a = [];
    for (var i=0, l=arr.length; i<l; i++)
        if (a.indexOf(arr[i]) === -1 && arr[i] !== '')
            a.push(arr[i]);
    return a;
}

function handleEventList() {
    var url = '/apps/api/ec/events';
    $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        success: function (result) {
            data_events = result.data.events;
            var data_dateOff = result.data.dayOff;
            // console.log(data_events);
            // console.log(data_dateOff);
            var date_events = [];
            for (var i = 0; i < data_events.length; i++) {
                var start_date_format = data_events[i].start_date;
                var end_date_format = data_events[i].end_date;
                start_date_format = start_date_format.split(' ');
                end_date_format = end_date_format.split(' ');
                list_date = getDaysArray(new Date(start_date_format[0]), new Date(end_date_format[0]));
                for (var j = 0; j < list_date.length; j++) {
                    date_events.push(list_date[j]);
                }
            }
            var date_off = [];
            for (var i = 0; i < data_dateOff.length; i++) {
                var start_date_format = data_dateOff[i].start_date;
                var end_date_format = data_dateOff[i].end_date;
                start_date_format = start_date_format.split(' ');
                end_date_format = end_date_format.split(' ');
                list_date = getDaysArray(new Date(start_date_format[0]), new Date(end_date_format[0]));
                for (var j = 0; j < list_date.length; j++) {
                    date_off.push(list_date[j]);
                }
            }
            var highlight_dates = uniqueArray2(date_events);
            var highlight_dates_off = uniqueArray2(date_off);
            $("#datepicker").datepicker({
                inline: true,
                selectWeek: true,
                beforeShowDay: function (date) {
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();
                    var day = ('0' + date.getDate()).slice(-2);
                  
                    // Change format of date
                    //                  var newdate = day+"-"+month+'-'+year;
                    var newdate = year + "-" + month + '-' + day;
                    // var highlight_dates = ['14-6-2021','16-6-2021','18-6-2021','28-6-2021'];
                    // Set tooltip text when mouse over date
                    var tooltip_text = newdate;
                    // Check date in Array
                    if (jQuery.inArray(newdate, highlight_dates) != -1) {
                        return [true, "highlight", tooltip_text];
                    }
                    if (jQuery.inArray(newdate, highlight_dates_off) != -1) {
                        return [true, "highlight_off", tooltip_text];
                    }
                    return [true, "unhighlight"];
                },
                onSelect: function (dateText, el) {
                    var day = el.selectedDay,
                        mon = el.selectedMonth,
                        year = el.selectedYear;

                    var el = $(el.dpDiv).find('[data-year="' + year + '"][data-month="' + mon + '"]').filter(function () {
                        return $(this).find('a').text().trim() == day;
                    });
                    if (el.hasClass('highlight')) {
                        var current_item = dateText;
                        current_item = current_item.split('/');
                        var current_item_format = new Date(current_item[0], (current_item[1] - 1), current_item[2], 7,0,0);
                        var content_event = "";
                        for (var i = 0; i < data_events.length; i++) {
                            var start_date_format = data_events[i].start_date;
                            var end_date_format = data_events[i].end_date;
                            start_date_format = start_date_format.split(' ');
                            end_date_format = end_date_format.split(' ');

                            var start_date_ev = (new Date(start_date_format[0]));
                            var end_date_ev = (new Date(end_date_format[0]));
                            if (start_date_ev.getTime() <= current_item_format.getTime() && current_item_format.getTime() <= end_date_ev.getTime()) {

                                var tmp_start_date = data_events[i].start_date;
                                    tmp_start_date = tmp_start_date.split(' ');
                                var tmp_start_date_time = tmp_start_date[1];
                                    tmp_start_date_time = tmp_start_date_time.split(':');

                                var tmp_end_date = data_events[i].end_date;     
                                    tmp_end_date = tmp_end_date.split(' ');
                                var tmp_end_date_time = tmp_end_date[1];
                                    tmp_end_date_time = tmp_end_date_time.split(':');

                                var min_tmp_start_date = tmp_start_date_time[1];
                                var min_tmp_end_date = tmp_end_date_time[1];
                                var hour_tmp_start_date = tmp_start_date_time[0];
                                var hour_tmp_end_date = tmp_end_date_time[0];
                                var txt_start_date = start_date_ev.getFullYear() + "年" + (start_date_ev.getMonth() + 1) + "月" + start_date_ev.getDate() + "日 " + hour_tmp_start_date + ":" + min_tmp_start_date;
                                var txt_end_date = end_date_ev.getFullYear() + "年" + (end_date_ev.getMonth() + 1) + "月" + end_date_ev.getDate() + "日 " + hour_tmp_end_date + ":" + min_tmp_end_date;
                                content_event += "<div class='content_event'><div class='event_image'><img src='https://storage.googleapis.com/okafoods.appspot.com/" + data_events[i].image + "' /></div><div class='event_description'><p class='cs-title-event'><strong>" + data_events[i].title + "</strong></p><p class='cs-info-event'>イベント時間:" + txt_start_date + " ~ " + txt_end_date + "</p><p class='event_description_content'>" + data_events[i].description + "</p></div></div>"
                            }
                        }
                        $("#dialog").html("<div class='container_content_event'>" + content_event + "</div>");
                        $("body").addClass("modal-open");
                        $("#dialog").dialog("open");
                        $(".ui-widget-overlay").on('click', function () {
                            $("body").removeClass("modal-open");
                            $("#dialog").dialog("close");
                        });
                    } else {
                        $("#dialog").dialog("close");
                    }
                }
            });
        }
    });
}
